import { render, staticRenderFns } from "./AvexCoaches.vue?vue&type=template&id=7a7b251e&scoped=true&lang=pug"
import script from "./AvexCoaches.vue?vue&type=script&lang=js"
export * from "./AvexCoaches.vue?vue&type=script&lang=js"
import style0 from "./AvexCoaches.vue?vue&type=style&index=0&id=7a7b251e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7b251e",
  null
  
)

export default component.exports